import React, { useState, useRef, useEffect } from "react";
import SecuritySettings from "./SecuritySettings/SecuritySettings";
import AlertSettings from "./AlertSettings/AlertSettings";
import "./GlobalSetting.scss";
import SubHeader from "../SubHeader";

const tabs = [
  { id: "securitySetting", label: "Security", Component: SecuritySettings },
  { id: "alert", label: "Alert", Component: AlertSettings },
];

const keyActions = {
  ArrowRight: (index, last) => (index === last ? 0 : index + 1),
  ArrowLeft: (index, last) => (index === 0 ? last : index - 1),
  Home: () => 0,
  End: (_index, last) => last,
};

const GlobalSetting = () => {
  const [activeScreen, setActiveScreen] = useState("securitySetting");
  const tabRefs = useRef([]);

  const handleKeyDown = (e, index) => {
    const lastIndex = tabs.length - 1;
    const action = keyActions[e.key];
    if (!action) return;

    e.preventDefault();
    const newIndex = action(index, lastIndex);
    setActiveScreen(tabs[newIndex].id);
    tabRefs.current[newIndex]?.focus();
  };

  const screenClasses = {
    securitySetting: "securitySettingMedia",
    alert: "alertSettingMedias",
  };

  useEffect(() => {
    tabRefs.current[0]?.focus();
  }, []);

  return (
    <div className="globalSettingWrapper main_ele_wrapper">
      <SubHeader heading="Global Settings" />

      <div className="menu_bar tabMenu_bar">
        <ul role="tablist">
          {tabs.map((tab, index) => (
            <li key={tab.id} role="none">
              <button
                id={`tab-${tab.id}`}
                role="tab"
                ref={(el) => (tabRefs.current[index] = el)}
                className={activeScreen === tab.id ? "active" : ""}
                tabIndex={activeScreen === tab.id ? 0 : -1}
                onClick={() => setActiveScreen(tab.id)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {tabs.map((tab) => (
        <div
          key={tab.id}
          data-testid={`tabpanel-${tab.id}`}
          id={`tabpanel-${tab.id}`}
          role="tabpanel"
          aria-labelledby={`tab-${tab.id}`}
          hidden={activeScreen !== tab.id}
          tabIndex={-1}
          className={`gsdeetails_wrapper ${screenClasses[tab.id]}`}
        >
          {activeScreen === tab.id && <tab.Component />}
        </div>
      ))}
    </div>
  );
};

export default GlobalSetting;
